<template>
  <div
    v-analytics.pageview="'other'"
    class="page other-page is-overlay"
  >
    <div class="other-page-tips">
      {{ tips }}
    </div>
    <b-button
      v-if="btn"
      type="is-primary"
      class="other-page-btn"
    >
      {{ btn }}
    </b-button>
    <b-button
      v-if="type === 'continue'"
      type="is-primary"
      class="other-page-btn"
    >
      重新回答
    </b-button>
  </div>
</template>

<script>
import { isOutEnv } from '@/utils/helper';

const MESSAGES = {
  default: {
    login_failed: '登录失败',
    unknown: '发生了未知错误',
    login_parameters_missing: '缺少登录参数',
    publishing: '问卷正在发布中，请稍后再访问',
  },
  out: {
    login_failed: 'Login failed',
    unknown: 'An unknown error occurred',
    login_parameters_missing: 'Login parameters missing',
    publishing: 'The questionnaire is being published, please visit again later',
  },
};

export default {
  name: 'Other',

  data() {
    return {
      progress: '',
      btn: '',
      tips: '',
      type: '',
    };
  },

  computed: {
    messages() {
      const curEnv = isOutEnv() ? 'out' : 'default';

      return MESSAGES[curEnv];
    },
  },

  created() {
    const { query } = this.$route;
    this.type = query.type;
    this.changeText();
  },

  methods: {
    changeText() {
      switch (this.type) {
        case 'closed':
          this.tips = this.$t('survey_suspended');
          break;
        case 'notexist':
          if (window.location.host.includes('out.')) {
            this.tips = 'The questionnaire does not exist';
          } else {
            this.tips = '该问卷不存在';
          }
          break;
        case 'answered':
          this.tips = this.$t('survey_answered');
          // this.btn = this.$t('view_the_answer')
          break;
        case 'invalid':
          this.tips = this.$t('Invalid_url');
          break;
        case 'invite':
          this.tips = '只有受邀用户才能参与回答';
          this.btn = '点击重新登录';
          break;
        case 'exit':
          this.tips = this.$t('thanks');
          break;
        case 'continue':
          this.tips = `之前的答题进度为${this.progress} 是否继续上次回答？`;
          this.btn = '继续回答';
          break;
        case 'login':
          this.tips = '该问卷需要登录后才能继续答题';
          this.btn = '点击登录';
          break;
        case 'loginFailed':
          this.tips = this.messages.login_failed;
          break;
        case 'login_parameters_missing':
          this.tips = this.messages.login_parameters_missing;
          break;
        case 'notinwhitelist':
          this.tips = this.$t('disqualification_of_answer');
          break;
        case 'unknown':
          this.tips = this.messages.unknown;
          break;
        case 'publishing':
          this.tips = this.messages.publishing;
          break;
        default:
          this.tips = this.messages.unknown;
          break;
      }
    },
  },
};
</script>

<style lang="scss">
  .other-page {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    background: #fff;
    padding: 0 75px / $px;
    &-tips {
      font-size: 32px / $px;
      line-height: $descLineHeight;
      color: #444;
      @include desktop {
        margin-bottom: $desktopNormalGap;
        font-size: 24px;
      }
      @include landscape {
        margin-bottom: $landscapeNormalGap;
        font-size: 36px / $px;
      }
    }
    &-btn {
      min-width: 100%;
      margin-top: $normalGap;
      margin-bottom: -$normalGap / 2;
      @include desktop {
        margin-top: 30px;
        min-width: 220px;
        font-size: 18px;
      }
      @include landscape {
        min-width: 220px;
        font-size: 18px;
      }
    }
  }
</style>
